import { useCallback } from 'react';
import { useCreateEmissorOrderPaymentMutation, } from '../services/contractOrderPaymentApi';
export function useEmissorCreateOrderPayment() {
    const [trigger, state] = useCreateEmissorOrderPaymentMutation();
    const createOrderPayment = useCallback((input) => trigger(input).unwrap(), [trigger]);
    return { createOrderPayment, isLoading: state.isLoading, isError: state.isError };
}
